const Settings = {
  Bank: "Settings.Bank",
  BankBalances: "Settings.BankBalances",
  BankBalancesDescription: "Settings.BankBalancesDescription",
  BankBalancesNoAccounts: "Settings.BankBalancesNoAccounts",
  BankBalancesCouldNotLoad: "Settings.BankBalancesCouldNotLoad",
  MySettings: "Settings.MySettings",
  MyProfile: "Settings.MyProfile",
  CompanySetting: "Settings.CompanySetting",
  SuperkollForm: "Settings.SuperkollForm",
  Information: "Settings.Information",
  CompanyNameDescription: "Settings.CompanyNameDescription",
  CompanyOrgNumber: "Settings.CompanyOrgNumber",
  CompanyOrgNumberDescription: "Settings.CompanyOrgNumberDescription",
  CompanyPhone: "Settings.CompanyPhone",
  CompanyPhoneDescription: "Settings.CompanyPhoneDescription",
  CompanyMail: "Settings.CompanyMail",
  CompanyMailDescription: "Settings.CompanyMailDescription",
  Addresses: "Settings.Addresses",
  VisitingAddress: "Settings.VisitingAddress",
  VisitingAddressDescription: "Settings.VisitingAddressDescription",
  BillingAddress: "Settings.BillingAddress",
  CustomerInvoices: "Settings.CustomerInvoices",
  Payment: "Settings.Payment",
  DefaultPaymentTerms: "Settings.DefaultPaymentTerms",
  DefaultPaymentTermsDescription: "Settings.DefaultPaymentTermsDescription",
  PaymentMethod: "Settings.PaymentMethod",
  PaymentMethodDescription: "Settings.PaymentMethodDescription",
  IBAN: "Settings.IBAN",
  IBANDescription: "Settings.IBANDescription",
  BIC: "Settings.BIC",
  BICDescription: "Settings.BICDescription",
  InvoiceManagement: "Settings.InvoiceManagement",
  InvoiceDeliveryMethod: "Settings.InvoiceDeliveryMethod",
  InvoiceDeliveryMethodDescription: "Settings.InvoiceDeliveryMethodDescription",
  InvoiceMail: "Settings.InvoiceMail",
  SendInvoicesFrom: "Settings.SendInvoicesFrom",
  SendInvoicesFromDescription: "Settings.SendInvoicesFromDescription",
  InvoiceEmailForCompany: "Settings.InvoiceEmailForCompany",
  InvoiceEmailForCompanyDescription: "Settings.InvoiceEmailForCompanyDescription",
  InvoiceMailDescription: "Settings.InvoiceMailDescription",
  FileNameTemplate: "Settings.FileNameTemplate",
  FileNameTemplateDescription: "Settings.FileNameTemplateDescription",
  SendInvoiceFrom_0: "Settings.SendInvoiceFrom_0",
  SendInvoiceFrom_1: "Settings.SendInvoiceFrom_1",
  SendInvoiceFrom_2: "Settings.SendInvoiceFrom_2",
  DisplaySettings: "Settings.DisplaySettings",
  InvoicePdfTemplate: "Settings.InvoicePdfTemplate",
  InvoicePdfTemplateDescription: "Settings.InvoicePdfTemplateDescription",
  InvoiceMessage: "Settings.InvoiceMessage",
  InvoiceMessageDescription: "Settings.InvoiceMessageDescription",
  HomePageUrl: "Settings.HomePageUrl",
  HomePageUrlDescription: "Settings.HomePageUrlDescription",
  UseFTax: "Settings.UseFTax",
  UseFTaxDescription: "Settings.UseFTaxDescription",
  HideDeliveryAddress: "Settings.HideDeliveryAddress",
  HideDeliveryAddressDescription: "Settings.HideDeliveryAddressDescription",
  Units: "Settings.Units",
  UnitName: "Settings.UnitName",
  ProfileSettings: "Settings.ProfileSettings",
  ProfileNameDescription: "Settings.ProfileNameDescription",
  ProfileMailDescription: "Settings.ProfileMailDescription",
  ProfilePhoneDescription: "Settings.ProfilePhoneDescription",
  ProfilePicture: "Settings.ProfilePicture",
  ProfilePictureDescription: "Settings.ProfilePictureDescription",
  DailyMails: "Settings.DailyMails",
  IncludeOverdueInvoices: "Settings.IncludeOverdueInvoices",
  IncludeOverdueInvoicesDescription: "Settings.IncludeOverdueInvoicesDescription",
  UseCompanySpecificEmail: "Settings.UseCompanySpecificEmail",
  UseCompanySpecificEmailDescription: "Settings.UseCompanySpecificEmailDescription",
  MailAddresses: "Settings.MailAddresses",
  MailAddressesDescription: "Settings.MailAddressesDescription",
  EmailsOnWeekdays: "Settings.EmailsOnWeekdays",
  EmailsOnWeekdaysDescription: "Settings.EmailsOnWeekdaysDescription",
  TableSize: "Settings.TableSize",
  TableSizeDescription: "Settings.TableSizeDescription",
  TableSizeType_0: "Settings.TableSizeType_0",
  TableSizeType_1: "Settings.TableSizeType_1",
  TableSizeType_2: "Settings.TableSizeType_2",
  PayReceipts: "Settings.PayReceipts",
  OwnExpenses: "Settings.OwnExpenses",
  CurrencySurcharge: "Settings.CurrencySurcharge",
  ReceiptPaymentMethodTypeDescription: "Settings.ReceiptPaymentMethodTypeDescription",
  ValueBetween0And5: "Settings.ValueBetween0And5",
  ValueBetween0And2: "Settings.ValueBetween0And2",
  SavedSettingsSuccessfully: "Settings.SavedSettingsSuccessfully",
  CompanyLogo: "Settings.CompanyLogo",
  CompanyLogoDescription: "Settings.CompanyLogoDescription",
  CreateNewSupportCase: "Settings.CreateNewSupportCase",
  ContactUs: "Settings.ContactUs",
  OneCompanyImage: "Settings.OneCompanyImage",
  OneProfileImage: "Settings.OneProfileImage",
  PersonInformation: "Settings.PersonInformation",
  PersonNumber: "Settings.PersonNumber",
  EmployeeNameDescription: "Settings.EmployeeNameDescription",
  EPost: "Settings.EPost",
  EmployeeTelephone: "Settings.EmployeeTelephone",
  EmployeeProfileImageDescription: "Settings.EmployeeProfileImageDescription",
  Rights: "Settings.Rights",
  SpeedDial: "Settings.SpeedDial",
  EPostDescription: "Settings.EPostDescription",
  EmployeeTelephoneDescription: "Settings.EmployeeTelephoneDescription",
  SupplierInvoices: "Settings.SupplierInvoices",
  DefaultSalaryDeviationPerson: "Settings.DefaultSalaryDeviationPerson",
  DeviationsViaMobile: "Settings.DeviationsViaMobile",
  DeviationsViaMobileDescription: "Settings.DeviationsViaMobileDescription",
  Salary: "Settings.Salary",
  AccountNumber: "Settings.AccountNumber",
  AccountNumberDescription: "Settings.AccountNumberDescription",
  ClearingNumber: "Settings.ClearingNumber",
  ClearingNumberDescription: "Settings.ClearingNumberDescription",
  TaxTable: "Settings.TaxTable",
  TaxTableDescription: "Settings.TaxTableDescription",
  TaxTableWintSalaryDescription: "Settings.TaxTableWintSalaryDescription",
  TaxAdjustment: "Settings.TaxAdjustment",
  SalaryType: "Settings.SalaryType",
  SalaryTypeDescription: "Settings.SalaryTypeDescription",
  EmploymentRate: "Settings.EmploymentRate",
  OtherSettings: "Settings.OtherSettings",
  AccountForExpenses: "Settings.AccountForExpenses",
  AccountForExpensesDescription: "Settings.AccountForExpensesDescription",
  ClearingNumberForExpensesDescription: "Settings.ClearingNumberForExpensesDescription",
  PausePayouts: "Settings.PausePayouts",
  PausePayoutsDescription: "Settings.PausePayoutsDescription",
  Assistants: "Settings.Assistants",
  AssistantsDescription: "Settings.AssistantsDescription",
  StandardSalary: "Settings.StandardSalary",
  BasicSettings: "Settings.BasicSettings",
  BankAccountInfo: "Settings.BankAccountInfo",
  BankAccountInfoDescription: "Settings.BankAccountInfoDescription",
  WorkplaceAndPersonalInfo: "Settings.WorkplaceAndPersonalInfo",
  StartDate: "Settings.StartDate",
  StartDateDescription: "Settings.StartDateDescription",
  StartDateNotFirstWarning: "Settings.StartDateNotFirstWarning",
  EditStartDate: "Settings.EditStartDate",
  RehireStartDateDescription: "Settings.RehireStartDateDescription",
  EndDate: "Settings.EndDate",
  EndDateDescription: "Settings.EndDateDescription",
  TerminationReason: "Settings.TerminationReason",
  TerminationReasonDescription: "Settings.TerminationReasonDescription",
  TerminationReasonLocked: "Settings.TerminationReasonLocked",
  ConcurrentVacationEndDateWarning: "Settings.ConcurrentVacationEndDateWarning",
  ConcurrentVacationEndDateWarningWithReason: "Settings.ConcurrentVacationEndDateWarningWithReason",
  TerminationReason_1: "Settings.TerminationReason_1",
  TerminationReason_6: "Settings.TerminationReason_6",
  TerminationReason_7: "Settings.TerminationReason_7",
  TerminationReason_8: "Settings.TerminationReason_8",
  WorkPlaceStreetAddress: "Settings.WorkPlaceStreetAddress",
  WorkPlaceStreetAddressDescription: "Settings.WorkPlaceStreetAddressDescription",
  WorkPlaceCity: "Settings.WorkPlaceCity",
  WorkPlaceCityDescription: "Settings.WorkPlaceCityDescription",
  WorkPlaceOptionalHint: "Settings.WorkPlaceOptionalHint",
  MonthlySalaryBeforeTax: "Settings.MonthlySalaryBeforeTax",
  MonthlySalaryBeforeTaxDescription: "Settings.MonthlySalaryBeforeTaxDescription",
  DefaultSalaryDeviationPersonDescription: "Settings.DefaultSalaryDeviationPersonDescription",
  SalaryActive: "Settings.SalaryActive",
  SalaryInactive: "Settings.SalaryInactive",
  ChangesApplyFrom: "Settings.ChangesApplyFrom",
  ApplyFrom: "Settings.ApplyFrom",
  NewEmployee: "Settings.NewEmployee",
  Employee: "Settings.Employee",
  EmployeeType_0: "Settings.EmployeeType_0",
  EmployeeType_1: "Settings.EmployeeType_1",
  EmployeeType_2: "Settings.EmployeeType_2",
  EmployeeType_3: "Settings.EmployeeType_3",
  EmployeeSettings: "Settings.EmployeeSettings",
  ActivateSalary: "Settings.ActivateSalary",
  DeactivateSalary: "Settings.DeactivateSalary",
  DeleteUser: "Settings.DeleteUser",
  EditUser: "Settings.EditUser",
  EmploymentRateDescription: "Settings.EmploymentRateDescription",
  PersonNumberRequired: "Settings.PersonNumberRequired",
  BankAccountMissing: "Settings.BankAccountMissing",
  ClearingNumberMissing: "Settings.ClearingNumberMissing",
  Project: "Settings.Project",
  CostCenter: "Settings.CostCenter",
  Standard: "Settings.Standard",
  StandardDescription: "Settings.StandardDescription",
  TagsDescription: "Settings.TagsDescription",
  Compulsory: "Settings.Compulsory",
  ActiveDimensionCategories: "Settings.ActiveDimensionCategories",
  NothingActivated: "Settings.NothingActivated",
  DimensionDuplicates: "Settings.DimensionDuplicates",
  Name: "Settings.Name",
  ShortName: "Settings.ShortName",
  SearchTags: "Settings.SearchTags",
  SearchUsers: "Settings.SearchUsers",
  EmploymentRateValidation: "Settings.EmploymentRateValidation",
  ScheduleStandardWorkTimeCannotBeChanged: "Settings.ScheduleStandardWorkTimeCannotBeChanged",
  ScheduleWorkTimeMismatch: "Settings.ScheduleWorkTimeMismatch",
  AppsCategory_0: "Settings.AppsCategory_0",
  AppsCategory_1: "Settings.AppsCategory_1",
  AppsCategory_2: "Settings.AppsCategory_2",
  AppsCategory_3: "Settings.AppsCategory_3",
  AppsCategory_4: "Settings.AppsCategory_4",
  AppsCategory_5: "Settings.AppsCategory_5",
  AppsCategoryDescription_1: "Settings.AppsCategoryDescription_1",
  AppsCategoryDescription_2: "Settings.AppsCategoryDescription_2",
  AppsCategoryDescription_3: "Settings.AppsCategoryDescription_3",
  AppsCategoryDescription_4: "Settings.AppsCategoryDescription_4",
  AppsCategoryDescription_5: "Settings.AppsCategoryDescription_5",
  WaitingForActivation: "Settings.WaitingForActivation",
  TimeReportingSettings: "Settings.TimeReportingSettings",
  IsTimeReportingMandatory: "Settings.IsTimeReportingMandatory",
  IsTimeReportingMandatoryDescription: "Settings.IsTimeReportingMandatoryDescription",
  TimeReportingInterval: "Settings.TimeReportingInterval",
  TimeReportingIntervalDescription: "Settings.TimeReportingIntervalDescription",
  TimeReportingInterval_0: "Settings.TimeReportingInterval_0",
  TimeReportingInterval_1: "Settings.TimeReportingInterval_1",
  EmployeeOtherReferenceName: "Settings.EmployeeOtherReferenceName",
  EmployeeOtherReferenceNameDescription: "Settings.EmployeeOtherReferenceNameDescription",
  ProfileLanguageDescription: "Settings.ProfileLanguageDescription",
  Reminders: "Settings.Reminders",
  ReminderCost: "Settings.ReminderCost",
  ReminderCostDescription: "Settings.ReminderCostDescription",
  PenaltyInterestType: "Settings.PenaltyInterestType",
  PenaltyInterestTypeDescription: "Settings.PenaltyInterestTypeDescription",
  PenaltyInterest: "Settings.PenaltyInterest",
  InterestRate: "Settings.InterestRate",
  InterestRateDescription: "Settings.InterestRateDescription",
  PenaltyInterestType_0: "Settings.PenaltyInterestType_0",
  PenaltyInterestType_1: "Settings.PenaltyInterestType_1",
  PenaltyInterestType_2: "Settings.PenaltyInterestType_2",
  AutomaticReminder: "Settings.AutomaticReminder",
  AutomaticReminderAmountLimit: "Settings.AutomaticReminderAmountLimit",
  AutomaticReminderAmountLimitDescription: "Settings.AutomaticReminderAmountLimitDescription",
  AutomaticReminderAmountLimitControlLabel: "Settings.AutomaticReminderAmountLimitControlLabel",
  AutomaticReminderPeriod: "Settings.AutomaticReminderPeriod",
  AutomaticReminderPeriodDescription: "Settings.AutomaticReminderPeriodDescription",
  AutomaticReminderPeriodControlLabel: "Settings.AutomaticReminderPeriodControlLabel",
  AutomaticReminderDelay: "Settings.AutomaticReminderDelay",
  AutomaticReminderDelayDescription: "Settings.AutomaticReminderDelayDescription",
  AutomaticReminderDelayControlLabel: "Settings.AutomaticReminderDelayControlLabel",
  AutomaticReminderCountLimit: "Settings.AutomaticReminderCountLimit",
  AutomaticReminderCountLimitDescription: "Settings.AutomaticReminderCountLimitDescription",
  AutomaticReminderCountLimitControlLabel: "Settings.AutomaticReminderCountLimitControlLabel",
  AutomaticReminderFeeDeprecationLimit: "Settings.AutomaticReminderFeeDeprecationLimit",
  AutomaticReminderFeeDeprecationLimitDescription: "Settings.AutomaticReminderFeeDeprecationLimitDescription",
  InvoiceReminderNotesTemplate: "Settings.InvoiceReminderNotesTemplate",
  InvoiceReminderNotesTemplateDescription: "Settings.InvoiceReminderNotesTemplateDescription",
  InvoiceReminderSendType: "Settings.InvoiceReminderSendType",
  InvoiceReminderSendTypeDescription: "Settings.InvoiceReminderSendTypeDescription",
  InvoiceReminderMail: "Settings.InvoiceReminderMail",
  InvoiceReminderMailDescription: "Settings.InvoiceReminderMailDescription",
  InvoiceReminderFileNameTemplate: "Settings.InvoiceReminderFileNameTemplate",
  InvoiceReminderFileNameTemplateDescription: "Settings.InvoiceReminderFileNameTemplateDescription",
  InvoiceReminderReminderRecipient: "Settings.InvoiceReminderReminderRecipient",
  BusinessUnit: "Settings.BusinessUnit",
  BusinessUnitDescription: "Settings.BusinessUnitDescription",
  RemoveEmployeeTitle: "Settings.RemoveEmployeeTitle",
  RemoveEmployee: "Settings.RemoveEmployee",
  RemoveEmployeeSucces: "Settings.RemoveEmployeeSucces",
  User: "Settings.User",
  EditPersonalNumber: "Settings.EditPersonalNumber",
  Position: "Settings.Position",
  PositionDescription: "Settings.PositionDescription",
  VacationDays: "Settings.VacationDays",
  VacationDaysDescription: "Settings.VacationDaysDescription",
  VacationCompensation: "Settings.VacationCompensation",
  VacationCompensationDescription: "Settings.VacationCompensationDescription",
  MonthlySalary: "Settings.MonthlySalary",
  MonthlySalaryDescription: "Settings.MonthlySalaryDescription",
  ActualSalaryHelpText: "Settings.ActualSalaryHelpText",
  HourlyWage: "Settings.HourlyWage",
  HourlyWageDescription: "Settings.HourlyWageDescription",
  OccupationalCategorisationDescription: "Settings.OccupationalCategorisationDescription",
  OccupationalCategorisation: "Settings.OccupationalCategorisation",
  OccupationalCategorisation_0: "Settings.OccupationalCategorisation_0",
  OccupationalCategorisation_1: "Settings.OccupationalCategorisation_1",
  UsualWorkHours: "Settings.UsualWorkHours",
  UsualWorkHoursDescription: "Settings.UsualWorkHoursDescription",
  UsualWorkHoursChangedWithoutEmploymentRateWarning: "Settings.UsualWorkHoursChangedWithoutEmploymentRateWarning",
  ScheduleDescription: "Settings.ScheduleDescription",
  ScheduleDescriptionHelpText: "Settings.ScheduleDescriptionHelpText",
  IncomingInvoicesSigneeWarning: "Settings.IncomingInvoicesSigneeWarning",
  ReceiptsAdminWarning: "Settings.ReceiptsAdminWarning",
  WorkPlace: "Settings.WorkPlace",
  UseArticleTags: "Settings.UseArticleTags",
  UseArticleTagsDescription: "Settings.UseArticleTagsDescription",
  AccountNumberForSalary: "Settings.AccountNumberForSalary",
  ClearingNumberForExpenses: "Settings.ClearingNumberForExpenses",
  ClearingNumberForSalary: "Settings.ClearingNumberForSalary",
  WorkingHours: "Settings.WorkingHours",
  Schedule: "Settings.Schedule",
  ScheduleSectionDescription: "Settings.ScheduleSectionDescription",
  WorkWeek: "Settings.WorkWeek",
  AddWeek: "Settings.AddWeek",
  EnteredTime: "Settings.EnteredTime",
  DifferenceFromExpectedWorkTime: "Settings.DifferenceFromExpectedWorkTime",
  EmployeePersonalInformation: "Settings.EmployeePersonalInformation",
  EmployeeSalaryInformation: "Settings.EmployeeSalaryInformation",
  EmployeeExpenseAccountSettings: "Settings.EmployeeExpenseAccountSettings",
  ScheduleChangesTitle: "Settings.ScheduleChangesTitle",
  ScheduleChangesDescription: "Settings.ScheduleChangesDescription",
  ReplaceExistingScheduleInfo: "Settings.ReplaceExistingScheduleInfo",
  UpcomingChanges: "Settings.UpcomingChanges",
  ScheduledChangesDescription: "Settings.ScheduledChangesDescription",
  ScheduledChangesEditInfo: "Settings.ScheduledChangesEditInfo",
  CurrentVersion: "Settings.CurrentVersion",
  ScheduledVersion: "Settings.ScheduledVersion",
  CancelScheduledChanges: "Settings.CancelScheduledChanges",
  CancelScheduledChangesTitle: "Settings.CancelScheduledChangesTitle",
  CancelScheduledChangesDescription: "Settings.CancelScheduledChangesDescription",
  CurrentVersionLockedInfo: "Settings.CurrentVersionLockedInfo",
  StopScheduling: "Settings.StopScheduling",
  RemoveScheduling: "Settings.RemoveScheduling",
  UserType: "Settings.UserType",
  }
export default Settings;